<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-alert color="primary" dark icon="mdi-close" border="left" prominent>
                        <h1>RouteOne Authentication Failure</h1>
                        Your RouteOne Authentication has failed. Please contact Client Services so that we can resolve
                        this for you.
                    </v-alert>
                    <!--                    <program-support-card :show-dealer-info-message="false" :enrolled-in-nissan-program="true" />-->
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>
<script>
export default {
    name: "RouteOneSsoFailure",
};
</script>
